export default "__VITE_ASSET__e8505b12__"